import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Customer-mode handoff: receives an impersonation token in the URL,
 * stores it as the session, refreshes auth, and routes to /app.
 *
 * The token's `imp` JWT claim links back to the platform operator so all
 * actions are traceable in the audit log.
 */
export default function CustomerModeHandoff() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const token = params.get("token");
  const orgName = params.get("org") || "customer";

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!token) {
        navigate("/login");
        return;
      }
      localStorage.setItem("td_session", token);
      sessionStorage.setItem("td_impersonation_banner", "1");
      await refresh();
      if (!cancelled) navigate("/app", { replace: true });
    })();
    return () => { cancelled = true; };
  }, [token, refresh, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="text-sm text-muted-foreground mb-2">Opening customer mode for</div>
        <div className="serif text-2xl text-primary">{orgName}</div>
        <div className="mt-6 text-xs text-muted-foreground">Signing you in…</div>
      </div>
    </div>
  );
}
